import { Button } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { useHistory } from 'react-router-dom';


export default function ImageSettingsBtn() {

  const history = useHistory();
  const goToSettings = () => {
    history.push('/settings'); // Assuming your settings route is '/settings'
  };
  return <Button onClick={goToSettings} style={{ color: "lightgray", background: "none", border: "1px solid rgb(187 146 35)", padding: "10px 20px" }
  } >
    <SettingsIcon fontSize='small' style={{ marginRight: "0.6rem" }} />
    Settings</Button >
}